import type { SpecSectionField } from 'Components/SpecSection/SpecSection.types';
import { VEHICLE_FUEL_TYPES } from 'Utilities/consts';

import { Colour } from './Colour';
import type { SpecificationSectionData } from './SpecificationSection';
import { shouldEnableBatteryOwnership } from './SpecificationSection.helpers';

export const ALLOWED_BATTERY_OWNERSHIP_VEHICLES = [
	{ allowedMake: 'renault' },
	{ allowedMake: 'nissan', allowedModel: 'leaf' },
];

export const SPECIFICATION_FIELDS: SpecSectionField<SpecificationSectionData>[] = [
	{
		fieldName: 'exterior',
		isVisible: () => true,
		label: () => 'Exterior',
		value: ({ exterior }) => <Colour value={exterior} />,
	},
	{
		fieldName: 'interior',
		isVisible: () => true,
		label: () => 'Interior',
		value: ({ interior }) => <>{interior === 'Leather' ? 'Full leather' : interior || '-'}</>,
	},
	{
		fieldName: 'bodyType',
		isVisible: () => true,
		label: () => 'Body type',
		value: ({ bodyType }) => <>{bodyType}</>,
	},
	{
		fieldName: 'transmission',
		isVisible: () => true,
		label: () => 'Transmission',
		value: ({ transmission }) => <>{transmission}</>,
	},
	{
		fieldName: 'fuel',
		isVisible: () => true,
		label: () => 'Fuel',
		value: ({ fuel }) => <>{fuel}</>,
	},
	{
		fieldName: 'batteryOwnership',
		isVisible: ({ value: { fuel, make, model } }) =>
			shouldEnableBatteryOwnership({
				fuel,
				make,
				model,
			}),
		label: () => 'Battery ownership',
		value: ({ batteryOwnership }) => <>{batteryOwnership ? 'Leased' : 'Owned'}</>,
	},
	{
		fieldName: 'chargingCable',
		isVisible: ({ value: { fuel } }) =>
			[VEHICLE_FUEL_TYPES.ELECTRIC, VEHICLE_FUEL_TYPES.HYBRID].some((validFuel) => fuel === validFuel),
		label: () => 'Charging cable',
		value: ({ chargingCable }) => <>{chargingCable}</>,
	},
	{
		fieldName: 'engineSize',
		isVisible: ({ value: { fuel } }) => fuel !== VEHICLE_FUEL_TYPES.ELECTRIC,
		label: () => 'Engine size',
		value: ({ engineSize }) => <>{engineSize ? `${engineSize} cc` : '-'}</>,
	},
];
